// @ts-nocheck
import React from 'react';
import ComingSoonPage from './ComingSoonPage';

const CoachPacketsPlaceholder: React.FC = () => (
  <ComingSoonPage
    title="Coach Packets"
    description="Generate and share college-coach packets and credentials per event."
  />
);

export default CoachPacketsPlaceholder;
